// Central registry for all static icon paths from /public/icons/
// Usage: import { ICONS } from '../shared/icons';
//        <img src={ICONS.editBlue} />

export const ICONS = {
  // General actions
  addSubtask: '/icons/addSubtask.svg',
  attachFile: '/icons/attachFile.svg',
  bulkEditComment: '/icons/bulkEditComment.svg',
  changeView: '/icons/changeView.svg',
  close: '/icons/close.svg',
  copyLink: '/icons/copyLink.svg',
  copyLinkTicket: '/icons/copyLinkTicket.svg',
  createChecklist: '/icons/createChecklist.svg',
  createTask: '/icons/createTask.svg',
  delete: '/icons/delete.svg',
  deleteRed: '/icons/deleteRed.svg',
  download: '/icons/download.svg',
  edit: '/icons/edit.svg',
  editBlue: '/icons/editBlue.svg',
  editBulk: '/icons/editBulk.svg',
  editIcon: '/icons/editIcon.svg',
  editTask: '/icons/editTask.svg',
  openInNewTab: '/icons/openInNewTab.svg',
  viewLink: '/icons/viewLink.svg',
  reset: '/icons/reset.svg',

  // Ticket fields
  assignee: '/icons/assignee.svg',
  assigneeBlue: '/icons/assigneeBlue.svg',
  calendar: '/icons/calendar.svg',
  calendarTicket: '/icons/calendarTicket.svg',
  dateRange: '/icons/dateRange.svg',
  dueDate: '/icons/dueDate.svg',
  estimation: '/icons/estimation.svg',
  labels: '/icons/labels.svg',
  priority: '/icons/priority.svg',
  sprint: '/icons/sprint.svg',
  status: '/icons/status.svg',
  taskType: '/icons/taskType.svg',
  timeEstimate: '/icons/timeEstimate.svg',
  tickets: '/icons/tickets.svg',
  
  // Dropdown icons
  dropdownProject: '/icons/dropdownIcons/project.svg',
  dropdownAssignee: '/icons/dropdownIcons/assignee.svg',
  dropdownTaskType: '/icons/dropdownIcons/taskType.svg',
  dropdownLabels: '/icons/dropdownIcons/labels.svg',
  dropdownPriority: '/icons/dropdownIcons/priority.svg',
  dropdownScrumSprint: '/icons/dropdownIcons/ph_person-simple-run-fill.svg',
  dropdownDateRange: '/icons/dropdownIcons/dateRange.svg',
  dropdownDueDate: '/icons/dropdownIcons/dueDate.svg',

  // Comments / history
  comment: '/icons/comment.svg',
  commentDisabled: '/icons/commentDisabled.svg',
  file: '/icons/file.svg',
  fileDisabled: '/icons/fileDisabled.svg',
  history: '/icons/history.svg',
  historyDisabled: '/icons/historyDisabled.svg',
  worklog: '/icons/worklog.svg',
  worklogDisabled: '/icons/worklogDisabled.svg',

  // Charts
  barGraph: '/icons/barGraph.svg',
  pieChart: '/icons/pie-chart.svg',

  // Dashboard / space stats
  activeProjects: '/icons/activeProjects.svg',
  aiAgentDeveloper: '/icons/aiAgentDeveloper.svg',
  aiAgentModel: '/icons/aiAgentModel.svg',
  inactiveProject: '/icons/InactiveProject.svg',
  myCurrentSprint: '/icons/myCurrentSprint.svg',
  notificationSystem: '/icons/notificationSystem.svg',
  projectAlert: '/icons/projectAlert.svg',
  projects: '/icons/projects.svg',
  totalSpace: '/icons/totalSpace.svg',
  totalUsers: '/icons/totalUsers.svg',
  userIcon: '/icons/userIcon.svg',

  // Navigation (sidebar)
  permission: '/icons/Permission.png.png',
  projectManagement: '/icons/project_management.png.png',
  reportsManagement: '/icons/reports_management.png.png',
  setting: '/icons/setting.png.png',
  spaceManagement: '/icons/space_management.png.png',
  strategistAgent: '/icons/strategist_agent.png.png',
  strategistConfig: '/icons/strategistConfig.svg',
  ticketManagement: '/icons/ticket_management.png.png',
  timesheet: '/icons/timesheet.png.png',
  userManagement: '/icons/user_management.png.png',
  backlogManagement: '/icons/backlog_mgmt.svg',
  sprintTimeline: '/icons/sprint_timeline.svg',
  sprintManagement: '/icons/sprint_mgmt.svg',
  dailyStandup: '/icons/scrum_icon.svg',
};

// Task-type icons (static references; dynamic resolution stays in iconUtils.js)
export const TASK_TYPE_ICONS = {
  assigned: '/icons/task-type/assigned.svg',
  blocked: '/icons/task-type/blocked.svg',
  blocker: '/icons/task-type/blocker.svg',
  bug: '/icons/task-type/bug.svg',
  buildPipeline: '/icons/task-type/buildPipeline.svg',
  cancelled: '/icons/task-type/cancelled.svg',
  cicdSetup: '/icons/task-type/cicdSetup.svg',
  closed: '/icons/task-type/closed.svg',
  dependencyManagement: '/icons/task-type/dependencyManagement.svg',
  deployment: '/icons/task-type/deployment.svg',
  detect: '/icons/task-type/detect.svg',
  environmentSetup: '/icons/task-type/environmentSetup.svg',
  errorFix: '/icons/task-type/errorFix.svg',
  feature: '/icons/task-type/feature.svg',
  feedback: '/icons/task-type/feedback.svg',
  improvement: '/icons/task-type/improvement.svg',
  inProgress: '/icons/task-type/inProgress.svg',
  onHold: '/icons/task-type/onHold.svg',
  productionIssue: '/icons/task-type/productionIssue.svg',
  regressionIssue: '/icons/task-type/regressionIssue.svg',
  requirementGethering: '/icons/task-type/requirementGethering.svg',
  review: '/icons/task-type/review.svg',
  riskManagement: '/icons/task-type/riskManagement.svg',
  sprintPlanning: '/icons/task-type/sprintPlanning.svg',
  stakeholder: '/icons/task-type/stakeholder.svg',
  statusReporting: '/icons/task-type/statusReporting.svg',
  task: '/icons/task-type/task.svg',
  testing: '/icons/task-type/testing.svg',
  todo: '/icons/task-type/todo.svg',
  warning: '/icons/task-type/warning.svg',
};
